<div class="contentGrid input-grid-gaps pt-2">
<!--    <app-input-user-multiselect-->
<!--        class="fr-2"-->
<!--        #selectUserComponent-->
<!--        [form]="form"-->
<!--        [label]="prefix + 'fields.users'"-->
<!--        id="users"-->
<!--        [serviceId]="dialogConfig.data.serviceId"-->
<!--        [employment]="dialogConfig.data.employments"-->
<!--    ></app-input-user-multiselect>-->
<!--    <div class="fr-2">Složka? Není to blbost?</div>-->
<!--    <div class="fr-2">Účastníci - pouze u rodin, co je rodina?</div>-->

    <app-date-input
        [form]="form"
        id="dateFrom"
        [prefix]="prefix"
        [disabled]="true"
        [showTime]="true"
    ></app-date-input>
    <app-date-input
        [form]="form"
        id="dateTo"
        [prefix]="prefix"
        [showTime]="true"
    ></app-date-input>
    <app-number-input
        #applicationsInput
        [form]="form"
        id="applications"
        [prefix]="prefix"
        (selectedValueChange)="setDuration($event)"
        [min]="0"
    ></app-number-input>

    @if (showDurationOther) {
        <app-number-input
            [form]="form"
            id="durationOther"
            [prefix]="prefix"
            [disabled]="true"
            [min]="0"
        ></app-number-input>
    }

    <app-number-input
        [form]="form"
        id="executions"
        [prefix]="prefix"
    ></app-number-input>

    <app-select-input
        [form]="form"
        id="type"
        [prefix]="prefix"
        [staticOptions]="store.typeOptions()"
        [autoDisplayFirst]="true"
    ></app-select-input>

    <app-select-input
        [form]="form"
        id="presence"
        [prefix]="prefix"
        [staticOptions]="store.presenceOptions()"
        [autoDisplayFirst]="true"
    ></app-select-input>

    @if (showDurationOther) {
        <app-number-input
            #durationNoteInput
            id="durationNote"
            [prefix]="prefix"
            (selectedValueChange)="setValue($event, 'durationNote')"
            [min]="0"
        ></app-number-input>
        <app-number-input
            #durationPreparationInput
            id="durationPreparation"
            [prefix]="prefix"
            (selectedValueChange)="setValue($event, 'durationPreparation')"
            [min]="0"
        ></app-number-input>
        <app-number-input
            #durationSelfReflectionInput
            id="durationSelfReflection"
            [prefix]="prefix"
            (selectedValueChange)="setValue($event, 'durationSelfReflection')"
            [min]="0"
        ></app-number-input>
    }

    <app-multi-select-input
        #areasInput
        class="fr-full"
        [form]="form"
        id="areas"
        labelKey="name"
        valueKey="id"
        [prefix]="prefix"
        [staticOptions]="store.data.getServiceSocialAreas()?.items || []"
        [showClear]="true"
    ></app-multi-select-input>

    <app-tags-input
        class="fr-2"
        [form]="form"
        id="tags"
        [prefix]="prefix"
        [suggestions]="store.data.searchWorkOfferTags()"
        (queryEvent)="queryTags($event)"
        [showClear]="true"
    ></app-tags-input>

    <app-multi-select-input
        class="fr-2"
        [form]="form"
        id="targets"
        [prefix]="prefix"
        [staticOptions]="store.data.getIndividualPlans()?.items?.[0]?.targets || []"
        valueKey="id"
        [showClear]="true"
    ></app-multi-select-input>

    <app-multi-select-input
        class="fr-2"
        [form]="form"
        id="projects"
        [prefix]="prefix"
        labelKey="name"
        [staticOptions]="store.data.getSocialProjects()?.items || []"
        valueKey="id"
        [showClear]="true"
    ></app-multi-select-input>

    <app-input-wysiwyg
        [form]="form"
        id="note"
        class="fr-full"
        [placeholder]="prefix + 'fields.note'"
        editorKey="socialServiceOfferDetail"
        [height]="300"
    ></app-input-wysiwyg>

</div>
